import _ from "lodash";
import { useCallback } from "react";
import { useMappedState } from "redux-react-hook";

import { IStore } from "src/core/shared/store";

import { IOrderVariant } from "../api/orders.api";

/**
 * Custom hook to retrieve an order variant by its ID.
 *
 * This hook provides a function to find and return an order variant from the global
 * `orderVariants` list based on a specified `orderVariantId`.
 *
 * @returns A function that accepts an `orderVariantId` and returns the corresponding
 *          order variant if found in the list, or `undefined` if not found.
 */

export const useOrderVariant = () => {
  const { orderVariants } = useMappedState((store: IStore) => ({ orderVariants: store.global.settings?.orderVariants || [] }));

  const getProductVariant = useCallback((orderVariantId: number) => {
    return _.find(orderVariants, ov => ov.id === orderVariantId) as IOrderVariant;
  }, [ orderVariants ]);

  return getProductVariant;
};
